<template>
    <div class="container px-0 d-flex flex-row justify-content-between pt-3">
        <b-navbar v-if="$auth.check()" toggleable="md" class="bg-light site w-100">
            <b-navbar-toggle target="navbarUserNavDropdown"/>


            <div class="d-md-none d-sm-block ml-auto">
                <header-timer
                    v-if="time"
                    :time="time"
                    class="px-3 py-3 text-right"
                    format="dd MMMM, yyyy HH:mm:ss"
                />
            </div>

            <b-collapse is-nav id="navbarUserNavDropdown">
                <b-navbar-nav>
                    <b-nav-item
                        link-classes="pl-0 text-dark"
                        v-for="item in personalMenu"
                        :key="item.id"
                        :to="{ name: item.name }"
                        active-class="active"
                        :class="{'user-menu-big-link': personalMenu.length > 5, 'mr-4': personalMenu.length <= 5, 'text-md-center': true}"
                        :link-classes="{'text-danger': notVerifiedAttr(item), 'text-nowrap': item.nowrap}"
                        @click="resetLotPage"
                    >{{ item.label }}
                        <b-badge pill v-if="item.badge && getCounter(item.badge) > 0"
                                 :variant="getBadgeVariant(item.badge)">
                            {{ getCounter(item.badge) }}
                        </b-badge>
                    </b-nav-item>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>
import HeaderTimer from '@features/HeaderTimer/HeaderTimer'

export default {
    name: "AppPersonalMenu",
    components: {HeaderTimer},
    props: {
        personalMenu: {
            type: Array
        },
        time: {
            required: false
        }
    },
    computed: {
        notReadMessagesCount() {
            return this.$store.state.Messages.usersNotRead
        },
        notReadOrganizersMessagesCount() {
            return this.$store.state.Messages.organizersNotRead
        },
        notVerified() {
            return this.$store.state.Users.notVerified ?? 0;
        },
        WithdrawsCount() {
            return this.$store.state.Withdraws.total;
        }
    },
    updated() {
        this.wait4authReady(() => {
            const role = this.$auth.watch?.data?.role
            const id = this.$auth.watch?.data?.id

            if (['user','operator', 'admin', 'organizer'].includes(role)) {
                this.$store.dispatch('Messages/fetchNotReadMessagesCount')
            }
            if (['operator', 'admin'].includes(role)) {
                // this.$store.dispatch('Users/fetchUsers')
            }
            if (['admin', 'operator-buhgalter'].includes(role)) {
                this.fetchWithdrawsCount();
            }

            //Передача данных для яндекс-метрики
            const yandexMetrikaId = document.head.querySelector('meta[name="yandex-metrika-id"]')
            if(yandexMetrikaId && yandexMetrikaId.content && typeof ym !== 'undefined') {
                ym(yandexMetrikaId.content, 'userParams', {
                    role: role,
                    UserID: id
                });
            }
        })
    },
    methods: {
        getCounter(name) {
            return this[name];
        },
        getBadgeVariant(name) {
            switch (name) {
                case 'notReadMessagesCount':
                    return 'danger'
                case 'notReadOrganizersMessagesCount':
                    return 'danger'
                case 'WithdrawsCount':
                    return 'danger'
                default:
                    return 'secondary'
            }
        },
        notVerifiedAttr(link) {
            if (!!this.notVerified && link.name === 'operator.users')
                return true
            return false
        },
        resetLotPage() {
            this.$store.commit('Lots/resetPage')
            this.$store.commit('MyLots/resetPage')
            this.$store.commit('UserLots/resetPage')
        },
        async fetchWithdrawsCount() {
            await this.$store.dispatch('Withdraws/adminFetchWithdrawsCount')
            if (this.$store.state.Withdraws.error) {
                this.$notify(this.$store.state.Withdraws.error, 'error', {timeout: 10000})
            }
        },
        wait4authReady(cb, time = 300) {
            if (this.$auth.ready()) {
                return cb()
            }

            setTimeout(() => {
                this.wait4authReady(cb, time)
            }, time)
        }
    },
}
</script>

<style scoped>
.user-menu-big-link {
    margin-right: 20px;
}

@media (max-width: 1200px) {
    .user-menu-big-link {
        margin-right: 10px;
        font-size: 0.9em;
    }
}

@media (max-width: 1000px) {
    .user-menu-big-link {
        margin-right: 10px;
        font-size: 0.6em;
    }
}

@media (max-width: 767px) {
    .user-menu-big-link {
        font-size: 1em;
    }
}

</style>
